import { ListboxInput } from '@reach/listbox';
import PropTypes from 'prop-types';
import * as React from 'react';
import { DEPRECATED_PROP_MESSAGES } from '../../constants/messages.js';
import { useId } from '../../hooks/use-id.js';
import { filterProps } from '../core/core.utils.js';
import { renderWithRef } from '../core/render-with-ref.js';
import 'tiny-warning';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { processStyleProps } from '../core/swan-style.js';
import { useFormFieldProps } from '../form/form.context.js';
import { SwanListboxContextProvider } from './listbox.context.js';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const propTypes = {
  sizeVariant: deprecatedProp(PropTypes.oneOf(['standard', 'mini']), DEPRECATED_PROP_MESSAGES.size),
  size: PropTypes.oneOf(['standard', 'mini']),
  skin: PropTypes.oneOf(['standard', 'link', 'error']),
  fullWidth: PropTypes.bool
};
const propKeysToRemove = Object.keys(propTypes);
const Listbox = renderWithRef('Listbox', propTypes, (props, ref) => {
  const formProps = useFormFieldProps(useId(props.id));
  const {
    as,
    component,
    children,
    className,
    sizeVariant = 'standard',
    size = sizeVariant,
    skin,
    fullWidth
  } = props;
  const classes = new Set(['swan-listbox-input']);
  if (size === 'mini') classes.add('swan-listbox-mini');
  if (skin === 'error' || (formProps === null || formProps === void 0 ? void 0 : formProps['aria-invalid'])) classes.add('swan-listbox-skin-error');
  if (skin === 'link') classes.add('swan-listbox-skin-link');
  if (fullWidth) classes.add('swan-listbox-full-width');
  if (className) classes.add(className);
  const filteredProps = filterProps(props, propKeysToRemove, processStyleProps(props, classes));
  return /*#__PURE__*/React.createElement(SwanListboxContextProvider, null, /*#__PURE__*/React.createElement(ListboxInput, _extends({
    as: as || component || 'div'
  }, filteredProps, formProps, {
    ref: ref
  }), children));
});
Listbox.defaultProps = {
  skin: 'standard'
};
export { Listbox };